<section class="image-text">
    <div class="image">
        <img src="./assets/images/bg-mobile%201.png" alt="zawsze po bezpiecznym starcie">
    </div>
    <div class="text-container">
        <h2 class="title font-bold">
            Zobacz też inne nasze akcje
        </h2>
        <p class="text">
            A wszystko po to,
            by zadbać o wszystko, co ważne.
        </p>
        <a routerLink="/dzielimyrazemdroge" target="_blank">
            <button class="btn-green"> Zobacz więcej</button>
        </a>
    </div>
</section>
